import React from 'react';
import BlogForm from './BlogForm';

const BlogCreate = ({ handleTabChange }) => {
    return (
        <div className="p-6">
            <h2 className="text-2xl font-bold mb-6 text-gray-800">Add New Blog</h2>
            <BlogForm key="add-form" onBack={() => handleTabChange('dashboard')} />
        </div>
    );
};

export default BlogCreate;
